(function() {
    // Defer execution until DOM is ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeProductPage);
    } else {
      initializeProductPage();
    }
  
    function initializeProductPage() {
      const variantDropdown = createVariantDropdown();
      const customDropdownContainer = document.getElementById('custom-variant-dropdown');
      const swatches = document.querySelectorAll('.variant-swatches .swatch');
      const productForm = document.querySelector('form[action="/cart/add"]');
      const addToCartButton = document.getElementById('product-add-to-cart');
      const errorMessage = document.getElementById('variant-error-message');
      const notifyForm = document.getElementById('notify_sold-out');
      let mainProductImageUrl;
  
      const lazyImageObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const lazyImage = entry.target;
            lazyImage.src = lazyImage.dataset.src;
            lazyImage.srcset = lazyImage.dataset.srcset;
            lazyImage.classList.remove("lazy");
            observer.unobserve(lazyImage);
          }
        });
      });
  
      document.querySelectorAll('img.lazy').forEach(img => lazyImageObserver.observe(img));
  
      // Debounce function
      function debounce(func, wait) {
        let timeout;
        return function executedFunction(...args) {
          const later = () => {
            clearTimeout(timeout);
            func(...args);
          };
          clearTimeout(timeout);
          timeout = setTimeout(later, wait);
        };
      }
  
      // Throttle function
      function throttle(func, limit) {
        let inThrottle;
        return function(...args) {
          if (!inThrottle) {
            func.apply(this, args);
            inThrottle = true;
            setTimeout(() => inThrottle = false, limit);
          }
        }
      }
      // Instead of declaring 'product', we'll use a function to get it
      function getProduct() {
        return JSON.parse(document.getElementById('ProductJson-product-template').textContent);
      }
  
      function createVariantDropdown() {
        var dropdown = document.createElement('select');
        dropdown.id = 'product-selectors';
        dropdown.name = 'id';
        return dropdown;
      }
  
      function updatePrice(variant) {
        if (variant) {
          var priceContainer = document.querySelector('.prices');
          if (priceContainer) {
            if (variant.compare_at_price > variant.price) {
              priceContainer.innerHTML = 
                '<span class="price on-sale" itemprop="price">' + formatMoney(variant.price) + '</span>' +
                '<span class="ayirac">|</span>' +
                '<span class="compare-price">' + formatMoney(variant.compare_at_price) + '</span>';
            } else {
              priceContainer.innerHTML = 
                '<span class="price" itemprop="price">' + formatMoney(variant.price) + '</span>';
            }
          }
        }
      }
  
      function formatMoney(cents) {
        return '£' + (cents / 100).toFixed(2);
      }
  
      function updateNotifyForm() {
          var selectedOption = variantDropdown.options[variantDropdown.selectedIndex];
      
          // **Eğer notifyForm DOM içinde varsa işlem yap, yoksa hiçbir şey yapma**
          if (!notifyForm) return;
      
          // **Swatch sırasını değiştirmeden sadece görünürlüğü ayarla**
          requestAnimationFrame(() => {
              notifyForm.style.display = selectedOption.classList.contains('unavailable') ? 'block' : 'none';
          });
      }
  
      function updateBreadcrumb(variantTitle) {
        var placeholder = document.getElementById('breadcrumb-variant-placeholder');
        var title = document.getElementById('breadcrumb-variant-title');
        
        if (placeholder && title) {
          if (variantTitle) {
            title.textContent = variantTitle;
            placeholder.style.display = 'inline';
          } else {
            placeholder.style.display = 'none';
          }
        }
      }
  
      function handleUrlVariant() {
        var pathSegments = window.location.pathname.split('/').filter(Boolean);
        if (pathSegments.length >= 2 && pathSegments[0] === 'products') {
          var variantName = pathSegments[pathSegments.length - 1];
          var options = variantDropdown.options;
          
          for (var i = 0; i < options.length; i++) {
            var optionText = options[i].textContent.trim().replace(/\s+/g, '-').toLowerCase();
            if (optionText === variantName) {
              variantDropdown.value = options[i].value;
              variantDropdown.dispatchEvent(new Event('change'));
              updateCustomSelect(options[i]);
              var swatch = document.querySelector('.swatch[data-variant-id="' + options[i].value + '"]');
              if (swatch) {
                swatch.classList.add('selected');
              }
              var imageUrl = options[i].getAttribute('data-image');
              updateProductImage(imageUrl);
              updateAddToCartButton(!options[i].classList.contains('unavailable'));
              updateBreadcrumb(options[i].textContent.trim());
              break;
            }
          }
        }
  
        var productSection = document.querySelector('.product-single');
        if (productSection) {
          productSection.scrollIntoView({ behavior: 'smooth' });
        }
      }
  
      function initializeSwatchControls() {        
          const variantSwatches = document.querySelector('.variant-swatches');
          const viewMoreLink = document.getElementById('view-more-link');
          const viewLessLink = document.getElementById('view-less-link');
          const variantControls = document.getElementById('variant-controls');
          const remainingCountSpan = document.getElementById('remaining-count');
          const initialVisibleCount = 18;
          const allSwatches = variantSwatches.querySelectorAll('.swatch');

          if (allSwatches.length > initialVisibleCount) {
            variantControls.style.display = 'block';
            updateSwatchVisibility();
            updateRemainingCount();
          }

          function updateSwatchVisibility() {
            allSwatches.forEach((swatch, index) => {
              if (index < initialVisibleCount || viewLessLink.style.display === 'inline') {
                swatch.style.display = '';
              } else {
                swatch.style.display = 'none';
              }
            });
          }

          function updateRemainingCount() {
            const remainingCount = allSwatches.length - initialVisibleCount;
            remainingCountSpan.textContent = remainingCount + "+";
          }

          viewMoreLink.addEventListener('click', (e) => {
            e.preventDefault();
            viewMoreLink.style.display = 'none';
            viewLessLink.style.display = 'inline';
            allSwatches.forEach(swatch => swatch.style.display = '');
          });

          viewLessLink.addEventListener('click', (e) => {
            e.preventDefault();
            viewMoreLink.style.display = 'inline';
            viewLessLink.style.display = 'none';
            updateSwatchVisibility();
          });
        }      
  
        function createCustomDropdown() {
            var product = getProduct();
            var inStockOptions = '';
            var soldOutOptions = '';
          
            product.variants.forEach(function(variant) {
              var imageUrl = variant.featured_image ? variant.featured_image.src : product.featured_image.src;
              var option = '<option ' +
                'data-image="' + imageUrl + '" ' +
                'value="' + variant.id + '" ' +
                (variant.available ? '' : 'class="unavailable"') + '>' +
                variant.title +
                '</option>';
          
              if (variant.available) {
                inStockOptions += option;
              } else {
                soldOutOptions += option;
              }
            });
          
            variantDropdown.innerHTML = '<option value="" disabled selected>Please select a color</option>' +
              '<optgroup label="In Stock:">' + inStockOptions + '</optgroup>' +
              '<optgroup label="Sold Out:">' + soldOutOptions + '</optgroup>';
            variantDropdown.style.display = 'none';
            productForm.appendChild(variantDropdown);
          
            var customSelect = document.createElement('div');
            customSelect.className = 'custom-select';
            var customOptions = document.createElement('div');
            customOptions.className = 'custom-options';
          
            // Add "Please select a color" option
            var pleaseSelectOption = document.createElement('div');
            pleaseSelectOption.className = 'custom-option';
            pleaseSelectOption.innerHTML = '<span>Please select a color</span>';
            customOptions.appendChild(pleaseSelectOption);
          
            // Add "In Stock" title
            var inStockTitle = document.createElement('div');
            inStockTitle.className = 'custom-option-title';
            inStockTitle.textContent = 'In Stock:';
            customOptions.appendChild(inStockTitle);
          
            // Add in-stock options
            for (var i = 1; i < variantDropdown.options.length; i++) {
              var option = variantDropdown.options[i];
              if (!option.classList.contains('unavailable')) {
                addCustomOption(option, customOptions);
              }
            }
          
            // Add "Sold Out" title
            var soldOutTitle = document.createElement('div');
            soldOutTitle.className = 'custom-option-title';
            soldOutTitle.textContent = 'Sold Out:';
            customOptions.appendChild(soldOutTitle);
          
            // Add sold-out options
            for (var i = 1; i < variantDropdown.options.length; i++) {
              var option = variantDropdown.options[i];
              if (option.classList.contains('unavailable')) {
                addCustomOption(option, customOptions);
              }
            }
          
            customSelect.innerHTML = 'Please select a color';
            customSelect.addEventListener('click', function(event) {
              event.stopPropagation();
              customOptions.style.display = customOptions.style.display === 'block' ? 'none' : 'block';
              customSelect.classList.toggle('open');
            });
          
            customDropdownContainer.appendChild(customSelect);
            customDropdownContainer.appendChild(customOptions);
          
            // Close dropdown when clicking outside
            document.addEventListener('click', function() {
              customOptions.style.display = 'none';
              customSelect.classList.remove('open');
            });
          
            // Set main product image and disable Add to Cart button
            setMainProductImage();
            updateAddToCartButton(false);
            errorMessage.style.display = 'none';
            updateBreadcrumb(''); // Reset breadcrumb on page load
            setTimeout(handleUrlVariant, 0);
          }
          
          function addCustomOption(option, customOptions) {
            var customOption = document.createElement('div');
            customOption.className = 'custom-option' + (option.classList.contains('unavailable') ? ' unavailable' : '');
            customOption.innerHTML = option.value ? 
              '<img src="' + option.getAttribute('data-image') + '" alt="' + option.text + '">' +
              '<span>' + option.text + '</span>' :
              '<span>' + option.text + '</span>';
            customOption.setAttribute('data-value', option.value);
            customOptions.appendChild(customOption);
          
            customOption.addEventListener('click', function() {
              var variantId = this.getAttribute('data-value');
              if (variantId) {
                variantDropdown.value = variantId;
                variantDropdown.dispatchEvent(new Event('change'));
                updateCustomSelect(variantDropdown.options[variantDropdown.selectedIndex]);
                var selectedOption = variantDropdown.querySelector('option[value="' + variantId + '"]');
                updateAddToCartButton(!selectedOption.classList.contains('unavailable'));
                errorMessage.style.display = 'none';
              } else {
                // Reset to "Please select a color"
                variantDropdown.selectedIndex = 0;
                updateCustomSelect(variantDropdown.options[0]);
                setMainProductImage();
                updateAddToCartButton(false);
              }
              customOptions.style.display = 'none';
            });
          }
  
      function setMainProductImage() {
        mainProductImageUrl = document.querySelector('.product-photo-container img').src;
        updateProductImage(mainProductImageUrl);
        forceUpdateAllProductImages(mainProductImageUrl);
      }
  
      function updateCustomSelect(selectedOption) {
        var customSelect = customDropdownContainer.querySelector('.custom-select');
        if (selectedOption.value) {
          customSelect.innerHTML = `
            <img src="${selectedOption.getAttribute('data-image')}" alt="${selectedOption.text}">
            <span>${selectedOption.text}</span>
          `;
        } else {
          customSelect.innerHTML = 'Please select a color';
        }
        customSelect.classList.toggle('unavailable', selectedOption.classList.contains('unavailable'));
      }
  
      function updateProductImage(imageUrl) {
        if (!imageUrl) {
          imageUrl = mainProductImageUrl;
        }
        
        // Main product image
        var mainImage = document.querySelector('.product-photo-container img');
        if (mainImage) {
          mainImage.src = imageUrl;
          mainImage.srcset = imageUrl;
        } else {
          console.error("Main product image not found");
        }

        // Update all product images
        var allProductImages = document.querySelectorAll('.product-single__media img');
        allProductImages.forEach(function(img) {
          img.src = imageUrl;
          img.srcset = imageUrl;
        });

        // Update zoom image if exists
        var zoomImage = document.querySelector('.zoomImg');
        if (zoomImage) {
          zoomImage.style.backgroundImage = `url('${imageUrl}')`;
        }

        // Trigger any custom events or functions that your theme might be using
        if (typeof Currency !== 'undefined' && Currency.convertAll) {
          Currency.convertAll(shopCurrency, jQuery('[name=currencies]').val());
        }
        if (typeof theme !== 'undefined' && theme.Images && theme.Images.preload) {
          theme.Images.preload(imageUrl, 'large');
        }
      }
  
      function forceUpdateAllProductImages(imageUrl) {
        var allImages = document.querySelectorAll('img');
        allImages.forEach(function(img) {
          if (img.src.includes('cdn.shopify.com') && img.src.includes('products')) {
            img.src = imageUrl;
            img.srcset = imageUrl;
          }
        });
      }
  
      function updateVariantUrl(variantId) {
        if (history.pushState) {
          var selectedOption = variantDropdown.querySelector('option[value="' + variantId + '"]');
          if (selectedOption) {
            var variantName = selectedOption.textContent.trim().replace(/\s+/g, '-').toLowerCase();
            var productHandle = document.querySelector('meta[property="og:url"]').content.split('/').pop().split('?')[0];
            var newPath = '/products/' + productHandle + (variantId ? '?' + variantName : '');
            var newUrl = window.location.protocol + "//" + window.location.host + newPath;
            window.history.pushState({path: newUrl}, '', newUrl);
          }
        }
      }
  
      function updateAddToCartButton(variantAvailable) {
        if (!addToCartButton) return;
      
        addToCartButton.disabled = !variantAvailable;
        addToCartButton.classList.toggle('disabled', !variantAvailable);
      
        if (variantAvailable) {
          addToCartButton.value = addToCartButton.getAttribute('data-add-to-cart-text') || 'Add to Cart';
          addToCartButton.classList.remove('sold-out');
        } else {
          addToCartButton.value = addToCartButton.getAttribute('data-sold-out-text') || 'Sold Out';
          addToCartButton.classList.add('sold-out');
        }
      
        var customSelect = customDropdownContainer.querySelector('.custom-select');
        if (customSelect) {
          customSelect.classList.toggle('unavailable', !variantAvailable);
        }
      
        addToCartButton.removeEventListener('click', handleAddToCartClick);
        addToCartButton.addEventListener('click', handleAddToCartClick);
      }
  
      function handleAddToCartClick(event) {
        if (variantDropdown.value === "") {
          event.preventDefault();
          event.stopPropagation();
          errorMessage.style.display = 'block';
          return false;
        } else {
          errorMessage.style.display = 'none';
          return true;
        }
      }
      
      // Event Listeners
      productForm.addEventListener('submit', function(event) {
        if (variantDropdown.value === "") {
          event.preventDefault();
          errorMessage.style.display = 'block';
          return false;
        }
      });
  
swatches.forEach(function (swatch) {
    swatch.addEventListener('click', function () {
        var variantId = this.getAttribute('data-variant-id');
        var imageUrl = this.getAttribute('data-image-url');

        // Dropdown'un seçimini değiştir
        variantDropdown.value = variantId;
        variantDropdown.dispatchEvent(new Event('change'));

        // UI güncellemeleri
        updateCustomSelect(variantDropdown.options[variantDropdown.selectedIndex]);
        updateProductImage(imageUrl);
        forceUpdateAllProductImages(imageUrl);
        updateVariantUrl(variantId);
        errorMessage.style.display = 'none';

        // **Tüm swatch'ları güncelle (Eski seçimi kaldır, yeni seçimi ekle)**
        swatches.forEach(s => s.classList.remove('selected'));
        this.classList.add('selected');

        // **Add to Cart güncellemesi (Stok kontrolü)**
        var selectedOption = variantDropdown.querySelector('option[value="' + variantId + '"]');
        if (selectedOption) {
            updateAddToCartButton(!selectedOption.classList.contains('unavailable'));
        }
    });
});  
variantDropdown.addEventListener('change', function () {
    var selectedVariantId = this.value;
    var selectedOption = this.options[this.selectedIndex];

    if (!selectedVariantId || !selectedOption) return;

    var product = getProduct();
    var selectedVariant = product.variants.find(variant => variant.id == selectedVariantId);
    var imageUrl = selectedOption.getAttribute('data-image');

  console.log("denem1: ", selectedVariant);
    if (!selectedVariant) return;

    // **Fiyat Güncelleme**
    updatePrice(selectedVariant);

    // **Bildirim formunu güncelle (Stok kontrolü)**
    // **Ekmek kırıntısını (breadcrumb) güncelle**
    updateBreadcrumb(selectedOption.textContent.trim());

    // **Swatch'ları güncelle (Dropdown’dan değişince, ilgili swatch seçilecek)**
    swatches.forEach(swatch => {
        if (swatch.getAttribute('data-variant-id') == selectedVariantId) {
            swatch.classList.add('selected');
          console.log("denem3: ");
        } else {
            swatch.classList.remove('selected');
          console.log("denem4: ");
        }
    });

    // **Ürün resmini güncelle (Seçili varyantın resmini kullan)**
    if (imageUrl) {
        updateProductImage(imageUrl);
        forceUpdateAllProductImages(imageUrl);
      console.log("denem2: ", imageUrl);
    }

    // **Dropdown'daki UI'yi güncelle**
    updateCustomSelect(selectedOption);

    // **URL’yi güncelle**
    updateVariantUrl(selectedVariantId);

    // **"Add to Cart" butonunu stok durumuna göre güncelle**
    updateAddToCartButton(selectedVariant.available);
});

       // Use throttle for scroll events
    window.addEventListener('scroll', throttle(() => {
        // Your scroll handling code here
      }, 100), { passive: true });
  
      // Use debounce for resize events
      window.addEventListener('resize', debounce(() => {
        // Your resize handling code here
      }, 250));      
  
      // Initialization
      initializeSwatchControls();
      createCustomDropdown();
      variantDropdown.dispatchEvent(new Event('change'));
      handleUrlVariant();
      window.addEventListener('popstate', handleUrlVariant);
    } 
  })();